import type { LiveTrade, LiveTradeStatus } from '../../types/kraken'

/** $1,234.56 — dollars always to the cent, sign handled by the caller. */
export const usd = (value: number) =>
  `$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

/** +$12.34 / −$5.00 */
export const signedUsd = (value: number) => `${value > 0 ? '+' : value < 0 ? '−' : ''}${usd(value)}`

export const pnlClass = (value: number | null | undefined) =>
  value == null || value === 0 ? 'text-gray-300' : value > 0 ? 'text-green-400' : 'text-red-400'

const STATUS_TONE: Record<LiveTradeStatus, string> = {
  validated: 'bg-gray-500/15 text-gray-300',
  abandoned: 'bg-gray-500/15 text-gray-400',
  submitting: 'bg-amber-500/15 text-amber-300',
  unknown: 'bg-amber-500/20 text-amber-200 ring-1 ring-amber-400/50',
  rejected: 'bg-red-500/15 text-red-300',
  pending_fill: 'bg-sky-500/15 text-sky-300',
  partially_filled: 'bg-amber-500/15 text-amber-300',
  open: 'bg-green-500/15 text-green-300',
  closing: 'bg-amber-500/15 text-amber-300',
  closed: 'bg-gray-500/15 text-gray-200',
  expired_unfilled: 'bg-gray-500/15 text-gray-400',
  cancelled_unfilled: 'bg-gray-500/15 text-gray-400',
}

/** The server's own wording, e.g. "Partially filled: 0.0005 of 0.001". */
export const LiveTradeStatusBadge = ({ trade }: { trade: LiveTrade }) => (
  <span
    className={`inline-block rounded px-2 py-0.5 text-xs font-semibold ${STATUS_TONE[trade.status] ?? ''}`}
    data-testid="trade-status"
    data-status={trade.status}
  >
    {trade.status_label}
  </span>
)

export const duration = (from: string | null, to?: string | null) => {
  if (!from) return '—'
  const ms = (to ? new Date(to).getTime() : Date.now()) - new Date(from).getTime()
  const mins = Math.max(Math.floor(ms / 60_000), 0)
  const d = Math.floor(mins / 1440)
  const h = Math.floor((mins % 1440) / 60)
  const m = mins % 60
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m`
}
